 import { authenticatedFetch } from "../Auth/Auth";
 import { getCurrentConfig } from '../../config/config';
 
 const config = getCurrentConfig();




export const getListings = async () => {
  try {
    const response = await authenticatedFetch(`${config.API_BASE_URL}/listings`, {
      method: 'GET',
      headers: {
        'Content-Type': 'application/json',
        'User-Agent': 'agentApp/1.0',
      }
    });
    
    if (response.ok) {
      const responseData = await response.json();
      return responseData;
    } else {
      const errorData = await response.text();
      throw new Error(`Error getting listings: ${response.status} - ${errorData}`);
    }
  } catch (error) {
   
    throw error;
  }
};

export const getListing = async (propertyID) => {
  try {
    const response = await authenticatedFetch(`${config.API_BASE_URL}/listing/${propertyID}`, {
      method: 'GET',
      headers: {
        'Content-Type': 'application/json',
        'User-Agent': 'agentApp/1.0',
      }
    });
    
    if (response.ok) {
      const responseData = await response.json();
      return responseData;
    } else {
      const errorData = await response.text();
      throw new Error(`Error getting listing: ${response.status} - ${errorData}`);
    }
  } catch (error) {
   
    throw error;
  }
};